import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import * as moment from "moment";
import { InvCreateInvVoucher } from "../../model/inv-CreateInvVoucher.model";

@Component({
  selector: "ngx-inv-CreateInVoucher-form",
  templateUrl: "./inv-CreateInvVoucher-form.component.html",
  styleUrls: ["./inv-CreateInvVoucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvCreateInvVoucherFormComponent extends BaseFormComponent<InvCreateInvVoucher> {
  itemColumns: form_control[];
  DateNow: string;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "InvCreateInvVoucher";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvCreateInvVoucher");
    super.ngOnInit();
    const m = moment();
    this.DateNow = m.locale("fa").format("YYYY/MM/DD");
  }

  setdefault(): void {
    if (!this.isMultiBranch) {
      this.formGroup.get("SendBranchId")?.enable();
      this.cd.markForCheck();
    } else {
      this.setValue("SendBranchId", this.accountService.authService.currentBranch?.Id);
      this.cd.markForCheck();
    }
  }

  addControl(): void {
    this.setValue("Number", this.model.Code);
    this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
    this.setValue("BranchId", this.accountService.authService.currentBranchId);
    this.setValue("FromDate", this.model.FromDate);
    this.setValue("ToDate", this.model.ToDate);
    this.setValue("SendBranchId", this.model.SendBranchId);
    this.setValue("SendInvDepositWareHouse", this.model.SendInvDepositWareHouse);
    this.cd.markForCheck();
  }
}
